import { ReactElement } from 'react'
import styles from './WebAboutUsScreen.module.scss'
import { DesktopBodyLarge, DesktopHeadlineLarge } from '../../Typography'
import { AboutUsScreenData } from './AboutUsScreen'
import { BackgroundSlideshow } from '../../components/background-slideshow/BackgroundSlideshow'

type Props = {
  data: AboutUsScreenData
}

export const WebAboutUsScreen = ({ data: { backgroundUrls } }: Props): ReactElement => {
  return (
    <div className={styles.container}>
      <BackgroundSlideshow images={backgroundUrls} />
      <DesktopHeadlineLarge marginBottom={2}>Über uns</DesktopHeadlineLarge>
      <div className={styles.gaplessBox}>
        <DesktopBodyLarge>
          Herzlich Willkommen bei FIGHTBACK-WRESTLING. Pro Wrestling ist eine Leidenschaft, die wir
          mit Euch allen gemeinsam teilen.
        </DesktopBodyLarge>
        <DesktopBodyLarge>Aus diesem Grund sind wir heute hier.</DesktopBodyLarge>
      </div>
      <div className={styles.gaplessBox}>
        <DesktopBodyLarge>
          Mit Beginn der Corona Pandemie wurde die Zusammenarbeit zwischen new Generation wrestling
          und German Hurricane Wrestling immer enger.
        </DesktopBodyLarge>
        <DesktopBodyLarge>
          Der FIGHTBACK-WRESTLING Brand entstand und wurde innerhalb kürzester Zeit ein bekannter
          Name in Wrestling Deutschland.
        </DesktopBodyLarge>
        <DesktopBodyLarge>
          Zwei etablierte Organisationen haben es sich zur Aufgabe gemacht, die Flagge für Wrestling
          in dieser schweren Zeit hochzuhalten.
        </DesktopBodyLarge>
        <DesktopBodyLarge>
          Die Kräfte und Ressourcen von nGw und GHW wurden vereint.
        </DesktopBodyLarge>
      </div>
      <div className={styles.gaplessBox}>
        <DesktopBodyLarge>
          Zudem haben eine Kooperation mit dem Wrestling Verband OIWA ins Leben gerufen.
        </DesktopBodyLarge>
        <DesktopBodyLarge>
          WWE Legende Sir Mo aus Dallas Texas, USA und Promoterin Lindsey Jordan aus England
          arbeiten seitdem sehr eng mit unserem Office zusammen.
        </DesktopBodyLarge>
        <DesktopBodyLarge>Gemeinsame Shows wurden auf die Beine gestellt.</DesktopBodyLarge>
        <DesktopBodyLarge>Nicht nur in Deutschland, auch in den USA und England.</DesktopBodyLarge>
        <DesktopBodyLarge>
          Im September 2024 kam dann direkt der nächste große Schritt.
        </DesktopBodyLarge>
        <DesktopBodyLarge>
          FIGHTBACK-WRESTLING ist wöchentlich im Fernsehen zu bewundern.
        </DesktopBodyLarge>
        <DesktopBodyLarge>
          Der OK:TV Mainz gibt uns jeden Sonntag um 22 Uhr eine Plattform.
        </DesktopBodyLarge>
        <DesktopBodyLarge>
          Zudem werden die FIGHTBACK Episoden auch auf MagentaTV und dem TV-Streaming-Anbieter
          Zattoo ausgestrahlt.
        </DesktopBodyLarge>
      </div>
      <DesktopBodyLarge>
        Gemeinsam mit Euch, der FIGHTBACK-Community, lassen wir die Hütte brennen.
      </DesktopBodyLarge>
      <div className={styles.gaplessBox}>
        <DesktopBodyLarge>
          Das FIGHTBACK Office möchte sich in diesem Zusammenhang bei allen Wrestlerinnen und
          Wrestlern, Helfern sowie bei jedem Fan und Zuschauer bedanken.
        </DesktopBodyLarge>
        <DesktopBodyLarge>Ohne Euch wäre das alles nicht realisierbar.</DesktopBodyLarge>
      </div>
      <div className={styles.gaplessBox}>
        <DesktopBodyLarge>Vielen Dank.</DesktopBodyLarge>
        <DesktopBodyLarge>
          Und vergesst nicht: Bei FIGHTBACK-WRESTLING kann alles passieren!
        </DesktopBodyLarge>
      </div>
    </div>
  )
}
